<template>
  <div>
    <spinner :show="isLoading" />
    <div v-if="!isLoading">
      <div v-if="allowPagination" class="pagination">
        <b-pagination
          v-if="totalOrgs > perPage"
          v-model="currentPage"
          :total-rows="totalOrgs"
          :per-page="perPage"
          aria-controls="org-table"
        ></b-pagination>
      </div>
      <b-table
        id="org-table"
        :items="orgs"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
      >
        <template v-slot:cell(name)="data">
          <router-link class="clickable underline" :to="{ name: adminUsersURL, params: { id: data.item.id } }">
            {{ data.item.name }}
          </router-link>
        </template>
        <template v-slot:cell(phone)="data">
          <a 
            v-if="data.item.phone" 
            :href="`tel:${data.item.phone}`"
          >
            {{ phoneNum(data.item.phone) }}
          </a>
        </template>
        <template v-slot:cell(enabled)="data">
          <toggle-button
            :value="data.item.isEnabled"
            :sync="true"
            :color="{checked: '#008565', unchecked: '#989799', disabled: '#989799'}"
            :width="40"
            @change="toggleDisabled(data.item)"
          />
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import routeNames from '../../util/routeNames';
import modalNames from '../../util/modalNames';
import transformPhoneNum from '../../util/dataTransformation';
import Spinner from '../Spinner';

export default {
  name: 'OrganizationTable',
  components: { Spinner, },
  props: {
    limit: {
      type: Number,
      default: 10
    },
    allowPagination: {
      type: Boolean,
      default: true
    },
    sortListBy: {
      type: String,
      default: 'entries'
    },
    isSortDesc: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      adminUsersURL: routeNames.ADMINUSERSBYORG.NAME,
      sortBy: this.sortListBy,
      sortDesc: this.isSortDesc,
      perPage: this.limit,
      currentPage: 1,
      fields: [
        {
          key: 'name',
          sortable: true
        },
        {
          key: 'contact',
          sortable: true
        },
        {
          key: 'phone',
          sortable: false
        },
        {
          key: 'recipientCount',
          label: 'Entries',
          sortable: true
        },
        {
          key: 'enabled',
          sortable: false,
          class: 'table-toggle'
        }
      ],
    }
  },
  computed: {
    isLoading() {
      return this.$store.getters.getIsOrgLoading;
    },
    orgs() {
      return this.$store.getters.getOrgs;
    },
    totalOrgs() {
      return this.orgs.length
    }
  },
  mounted() {
    this.$store.dispatch('listOrgs');
  },
  methods: {
    toggleDisabled(item) {
      console.log('Item being toggled: ', item);
      const org = {
        ...item,
      };
      this.$store.dispatch('setOrgToUpdate', org);
      this.$bvModal.show(modalNames.DISABLE_ORG_CONFIRMATION_MODAL);
    },
    phoneNum(phoneNumStr) {
      return transformPhoneNum(phoneNumStr);
    }
  }
}
</script>
